export default __webpack_public_path__ + "static/media/T_65_desktop.cfaccf93.jpg";